import { render } from "./AppDisclaimer.vue?vue&type=template&id=7f3e31c1&ts=true"
import script from "./AppDisclaimer.vue?vue&type=script&lang=ts"
export * from "./AppDisclaimer.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__